@if (name && extension) {
  <div class="m-auto"
    [ngStyle]="{'height': height, 'width': width, 'background': background || 'url(../../../assets/images/' + name + extension +') no-repeat center / contain',  'mask': 'url(../../../assets/images/' + name + extension +') no-repeat center / contain', '-webkit-mask':' url(../../../assets/images/' + name + extension +') no-repeat center / contain'}">
  </div>
}